export default {
    USER_NOT_FOUND: 'USER_NOT_FOUND',
    USER_DELETED: 'USER_DELETED',
    BUSINESS_NOT_FOUND: 'BUSINESS_NOT_FOUND',
    DEVICE_NOT_FOUND: 'DEVICE_NOT_FOUND',
    DEVICE_DELETED: 'DEVICE_DELETED',
    DEVICE_NOT_AUTHORIZED: 'DEVICE_NOT_AUTHORIZED',
    REGISTRATION_NOT_FOUND: 'REGISTRATION_NOT_FOUND',
    REGISTRATION_EXPIRED: 'REGISTRATION_EXPIRED',
    CARD_NOT_FOUND: 'CARD_NOT_FOUND',
    TRANSACTION_NOT_FOUND: 'TRANSACTION_NOT_FOUND',
    OVERDRAFT_LIMIT_NOT_FOUND: 'OVERDRAFT_LIMIT_NOT_FOUND',
    CARD_ATTACHMENT_NOT_FOUND: 'CARD_ATTACHMENT_NOT_FOUND',
};
//# sourceMappingURL=notFound.js.map